export default {
  platformName: '服务商',
  deviceConfig: {
    distribute: '下发',
    distributeLog: '下发日志',
    devOffLine: '设备离线，暂无法操作',
    ctrlGateWayPair1: '开启配对',
    ctrlGateWayPair0: '关闭配对',
    noActionItems: '暂无可操作项',
    configDistribute: '配置下发',
    issueValue: '下发项',
    issueCommand: '下发指令',
    alarmThreshold: '报警阈值',
    trigger: '触发方式',
    mode: '模式',
    control: '控制方式',
    handMovement: '手动',
    automatic: '自动',
    upperLimit: '上限',
    lowerLimit: '下限',
    cycle: '周期',
    open: '打开',
    close: '关闭',
    open1: '开启',
    delScheduledConfig: '是否删除该定时配置',
    emergencyContact: '紧急联系人',
    familyContacts: '亲情号码',
    timedReminder: '定时提醒',
    reminderTime: '提醒时间',
    isDuplicate: '是否重复',
    reminderCycle: '提醒周期',
    reminderCycleEmptyTip: '请选择提醒周期',
    reminderContent: '提醒内容',
    reminderContentEmptyTip: '请输入提醒内容',
    uploadStatus: '下发状态',
    Issueing: '下发中',
    issuedSuccess: '下发成功',
    issuedFail: '下发失败',
    issuedTimeout: '下发超时',
    operationContext: '操作内容',
    operationTime: '操作时间',
    unlock: '解锁',
    lockMachine: '锁机',
    grade: '等级',
    // 报警使能
    fireAlarmEnable0: '过流',
    fireAlarmEnable1: '过压',
    fireAlarmEnable2: '欠压',
    fireAlarmEnable3: '过温',
    fireAlarmEnable4: '掉电',
    fireAlarmEnable5: '电弧',
    fireAlarmEnable6: '过载',
    fireAlarmEnable9: '缺相',
    fireAlarmEnable10: '三相不平衡',
    fireAlarmEnable11: '缺零',
    fireAlarmEnable12: '错相',
    fireAlarmEnable13: '零火反接',
    fireAlarmEnable14: '过温预警',
    fireAlarmEnable15: '过流预警',
    fireAlarmEnable16: '过压预警',
    fireAlarmEnable17: '欠压预警',
    fireAlarmEnable18: '过载预警',
    fireAlarmEnable19: '漏电预警',
    fireAlarmEnable21: '打火',
    fireAlarmEnable22: '浪涌',
    fireAlarmEnable23: '接地故障',
    fireAlarmEnable24: '过功率',
    fireAlarmEnable25: '过电量',
    fireAlarmEnable30: '漏电',
    onlineStatus: '在离线状态',
    // 跳闸使能
    tripEnable0: '过流',
    tripEnable2: '欠压',
    tripEnable4: '过温',
    tripEnable5: '掉电',
    tripEnable6: '电弧',
    tripEnable9: '过载',
    tripEnable10: '缺相',
    tripEnable11: '三相不平衡',
    tripEnable18: '零火反接',
    tripEnable21: '打火',
    tripEnable22: '接地故障',
    tripEnable23: '自动恢复',
    tripEnable24: '过功率',
    tripEnable25: '过电量',
    tripEnable30: '漏电',
    // 声音配置
    alarmTone: '报警音',
    faultTone: '故障音',
    touchTone: '按键音',
    electricalFire: '电气火灾',
    energy: '能源',
    powerQuality: '电能质量',
    // 输出联动模式
    mode1: '火灾报警',
    mode2: '火灾故障',
    mode3: '烟感报警',
    mode4: '燃气报警',
    mode6: '水浸报警',
    mode7: '不联动',
    mode8: '声光联动',
    mode9: '声联动',
    mode10: '光联动',
    // 输入参数标签
    imputLable1: '压力报警上限(MPa)',
    imputLable2: '压力报警下限(MPa)',
    imputLable3: '水压波动阈值(MPa)',
    imputLable4: '撞击报警值',
    imputLable5: '倾斜角度阈值(°)',
    imputLable6: '数据采样间隔(秒)',
    imputLable7: '数据上报间隔(分钟)',
    imputLable8: '液位报警上限(m)',
    imputLable9: '液位报警下限(m)',
    imputLable10: '液位波动报警(m)',
    imputLable11: '水压波动阈值(MPa)',
    // 上下限提示
    upperLowerTip1: '压力报警上限必须大于压力报警下限',
    upperLowerTip2: '液位报警上限必须大于液位报警下限',
    // 锁机等级提示
    lockLevelTips1: '等级1：禁止本地手动分合闸。',
    lockLevelTips2: '等级2：禁止本地手动分合闸、禁止本地修改参数。',
    lockLevelTips3: '等级3：禁止本地手动分合闸、禁止本地修改参数、禁止本地消音。',
    // 警告提示
    warningTip1: '请选择锁机等级',
    warningTip2: '设备锁机不能与其他配置项同时下发',
    warningTip3: '请完善表单信息',
    warningTip4: '请完善定时提醒信息',
    warningTip5: '压力参数无变化，请修改后再下发',
    warningTip6: '数据间隔参数无变化，请修改后再下发',
    warningTip7: '液位参数无变化，请修改后再下发',
    warningTip8: '液压参数无变化，请修改后再下发',
    warningTip9: '{name}不能为空',
    // WiFi配置
    wifiName: 'WiFi名称',
    wifiPsw: 'WiFi密码',
    wifichange: 'WiFi切换',
    // 配置文件
    hostPwd: '主机密码',
    pleasehostPwd: '请输入主机密码',
    pleasehostPwd4L: '请输入4-8位数字密码',
    profile: '配置文件',
    distributeProfile: '下发配置文件',
    pleaseCheckProfile: '请上传配置文件',
    // 从其他命名空间迁移的词条
    operate: '操作',
    yes: '是',
    no: '否',
    wrongNumType: '只允许输入数字',
    time: '时间',
    config: '配置',
    clickupload: '点击上传',
    selectAll: '全选',
    milicon: ':',
    pleasePsw: '请输入密码',
    pswMax8: '密码不能超过8字符',
    name: '名称',
    circuitNum: '回路号',
    channelNum: '通道号',
    detector: '探测器',
    videoChannel: '视频通道',
    dev: '设备',
    wifiOther: '其他',
    clickRefresh: '点击刷新',
    onlyCFG: '导入文件只支持.cfg格式',
    systemAddr: '系统地址/控制器编号',
    channelCode: '通道号/节点号',
    choosetime: '选择时间',
    airSwitchOperation: '空开操作',
    pleaseWiFiIP: '请输入WiFi密码',
    pleaseSelectWiFi: '请选择WiFi',
    queryFail: '查询失败！',
    sureIssue: '确认下发{name}吗？',
    prompt: '提示',
    delTip: '确定要删除选中的数据吗？',
    delTip1: '此操作将清空所有已选数据，是否继续？'
  },
  // 空开相关
  airSwitch: {
    view: '查看',
    selectAll: '全选',
    precisionMode: '精准模式',
    energyConsumptionMode: '能耗模式',
    within: '在',
    model1: '内，电量超标触发报警',
    model2: '内，用电量超标触发报警',
    powerConsumptionExceedsTriggerAlarm: '用电量超标触发报警',
    riseWithinMinutesTriggerWarning: '分钟内上升...℃触发预警',
    restartTime: '重启时间',
    pleaseSelect: '请选择',
    pleaseSelectTime: '请选择时间',
    second: '秒',
    hour: '小时',
    never: '从不',
    everyday: '每天',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期日',
    scheduledTaskSetting: '定时任务设置',
    confirmBatchDelete: '确定要批量删除选中的任务吗？',
    confirmDelete: '确定要删除该任务吗？',
    taskTip: '提示：定时任务最多支持20条',
    detector: '探测器',
    detectorName: '探测器名称',
    detectorModel: '探测器型号',
    channelNumber: '通道号',
    operationType: '操作类型',
    taskType: '任务类型',
    executionTime: '执行时间',
    operation: '操作',
    openGate: '合闸',
    closeGate: '分闸',
    repeatTask: '重复任务',
    singleTask: '单次任务',
    addScheduledTask: '新增定时任务',
    cancel: '取消',
    pleaseSelectDetector: '请选择探测器',
    pleaseSelectOperation: '请选择操作类型',
    pleaseSelectTaskType: '请选择任务类型',
    pleaseSelectExecutionTime: '请选择执行时间',
    pleaseSelectCycle: '请选择周期',
    operationFailed: '操作失败',
    // 报警使能
    overCurrentAlarmEnable: '过流报警使能',
    overVoltageAlarmEnable: '过压报警使能',
    underVoltageAlarmEnable: '欠压报警使能',
    overTemperatureAlarmEnable: '过温报警使能',
    powerFailureAlarmEnable: '掉电报警使能',
    arcAlarmEnable: '电弧报警使能',
    overloadAlarmEnable: '过载报警使能',
    leakageAlarmEnable: '漏电报警使能',
    phaseFailureAlarmEnable: '缺相报警使能',
    threePhaseImbalanceAlarmEnable: '三相不平衡报警使能',
    neutralMissingAlarmEnable: '缺零报警使能',
    phaseErrorAlarmEnable: '错相报警使能',
    neutralLiveReverseAlarmEnable: '零火反接报警使能',
    temperatureWarningEnable: '温度预警使能',
    overCurrentWarningEnable: '过流预警使能',
    overVoltageWarningEnable: '过压预警使能',
    underVoltageWarningEnable: '欠压预警使能',
    overloadWarningEnable: '过载预警使能',
    leakageWarningEnable: '漏电预警使能',
    // 动作使能
    overCurrentAlarmActionEnable: '过流动作使能',
    overVoltageAlarmActionEnable: '过压动作使能',
    underVoltageAlarmActionEnable: '欠压动作使能',
    overTemperatureAlarmActionEnable: '过温动作使能',
    overloadAlarmActionEnable: '过载动作使能',
    arcAlarmActionEnable: '电弧动作使能',
    powerFailureAlarmActionEnable: '掉电动作使能',
    leakageAlarmActionEnable: '漏电动作使能',
    phaseFailureAlarmActionEnable: '缺相动作使能',
    threePhaseImbalanceAlarmActionEnable: '三相不平衡动作使能',
    neutralLiveReverseActionEnable: '零火反接动作使能',
    groundFaultAlarmActionEnable: '接地故障动作使能',
    alarmAutoRecoveryActionEnable: '报警自动恢复动作使能'
  },
  // 视频监控
  videoModules: {
    pausePlayback: '暂停',
    startPlaying: '播放',
    cutPic: '截图',
    localRecording: '本地录像',
    closeIntercom: '关闭对讲',
    openIntercom: '开启对讲',
    closeSound: '关闭声音',
    openSound: '打开声音',
    switchHD: '切换到高清',
    switchSD : '切换到标清',
    SD: '标清',
    HD: '高清',
    stop: '停止',
    switchDevRecording: '切换到设备录像',
    switchCloudVideoRecording: '切换到云录像',
    cloud: '云',
    dev: '设备',
    splitScreen: '{num}分屏',
    closeAll: '关闭所有',
    fullScreen: '全屏',
    selectDate: '选择日期',
    deviceOffLineNum: '设备离线',
    screenshotTip: '截图前请先播放视频',
    recordTip: '录像前请先直播',
    talkTip: '对讲前请先直播',
    toggleMuteTip: '对讲时不能操作声音',
    noVideoStream: '未获取到流',
    noPanTilt: '当前窗口没有有效视频播放，无法操作云台',
    PTZ: '云台操作',
  },
  // HTTP请求相关
  request: {
    errors: {
      badRequest: '请求错误',
      unauthorized: '未授权，请重新登录',
      forbidden: '拒绝访问',
      notFound: '请求地址不存在',
      serverError: '服务器内部错误',
      badGateway: '网关错误',
      serviceUnavailable: '服务不可用',
      gatewayTimeout: '网关超时',
      networkError: '网络连接异常，请稍后重试',
      serviceException: '服务异常！',
      loginExpired: '登录已过期，请重新登录'
    },
    success: {
      operation: '操作成功！'
    }
  },
  common: {
    pleaseSelect: '请选择',
    pleaseInput: '请输入',
    confirm: '确定',
    cancel: '取消',
    deleteSuccess: '删除成功',
    back: '返回',
    placeholder: '请输入关键词搜索',
    pleaseSelectDeleteItem: '请先勾选要删除的数据',
    buttons: {
      search: '查询',
      reset: '重置',
      add: '新增',
      delete: '删除',
      view: '查看', // 对应图标按钮的语意
      edit: '编辑', // 对应图标按钮的语意
      cancel: '取消',
      confirm: '确定',
      save: '保存',
      refresh: '刷新',
      export: '导出'
    },
    tips: {
      prompt: '提示',
      confirm: '确定',
      cancel: '取消',
      sureIssue: '确认下发{name}吗？',
    },
    months: {
      1: '1月',
      2: '2月',
      3: '3月',
      4: '4月',
      5: '5月',
      6: '6月',
      7: '7月',
      8: '8月',
      9: '9月',
      10: '10月',
      11: '11月',
      12: '12月'
    },
    date: {
      Monday: '星期一',
      Tuesday: '星期二',
      Wednesday: '星期三',
      Thursday: '星期四',
      Friday: '星期五',
      Saturday: '星期六',
      Sunday: '星期日',
      minute: '分钟',
      hour: '小时',
      day: '天',
      week: '周',
      month: '月',
      year: '年',
    }
  },
  menus: {
    '安装商': '安装商',
    '设备运维': '设备运维',
    '站点管理': '站点管理',
    '报警值守': '报警值守',
    '消息中心': '消息中心',
    '客户管理': '客户管理',
    '我的单位': '我的单位',
    '用户管理': '用户管理',
    '角色管理': '角色管理',
    '站点列表': '站点列表',
    '站点详情': '站点详情',
    '设备详情': '设备详情',
    '管理员端': '管理员端',
    '权限管理': '权限管理',
    'APP端': 'App端',
    '首页': '首页',
    '报警日志': '报警日志',
    '故障日志': '故障日志',
    '发现': '发现',
    '设备管理': '设备管理',
    '视频监控': '视频监控',
    '我的': '我的',
    '消息': '消息'
  },
  user: {
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    account: '账号',
    name: '姓名',
    role: '角色',
    enabled: '是否启用',
    enable: '启用',
    deactivate: '停用',
    email: '邮箱',
    orgName: '所属部门',
    phone: '电话',
    dept: '部门',
    roleCfg: '角色配置',
    dataPermCfg: '数据权限配置',
    candidate: '待选列表',
    selected: '已选列表',
    selectAll: '全选',
    clear: '清空',
    add: '新增用户',
    edit: '编辑用户',
    batchDel: '批量删除',
    back: '返回',
    placeholder: '组织/站点/行政区划',
    searchHolder: '账号/姓名/邮箱',
    resetPsw: '重置密码',
    setPsw: '设置密码',
    pswSendType1: '以邮箱形式发送随机密码',
    pswSendType2: '自定义密码修改',
    resetPswSuccess: '重置密码成功',
    userNameTip1: "5-25个字符，支持字母、数字、特殊字符_. {'@'}不支持输入纯数字",
    userNameTip2: '请勿包含身份证/银行卡等隐私信息，一旦设置成功无法修改',
    wrongUserName1: '请输入5-25个字符',
    wrongUserName: '请输入正确账号',
    modifyPwd: '修改密码',
    modifyEmail: '修改邮箱',
    cancel: '注销',
    cancelS: '注销成功',
    logout: '退出',
    cancelTip1: '1. 注销请慎重，操作不可逆；',
    cancelTip2: '2. 单位不欠费，单位下面没有站点和设备。',
    sureLogoff: '确定注销？'
  },
  role: {
    name: '角色名称',
    createTime: '创建时间',
    remark: '备注',
    enterName: '请输入角色名称',
    add: '新增角色',
    edit: '编辑角色',
    inputRemark: '请输入备注',
    webPerm: 'WEB权限',
    adminMenu: '管理端菜单',
    appPerm: 'APP权限',
    mobileMenu: '移动端菜单'
  },
  customer: {
    siteCount: '站点数量',
    add: '新增客户',
    edit: '编辑客户',
    dialog: {
      fields: {
        account: '客户账号',
        name: '客户名称',
        phone: '客户电话'
      },
      placeholders: {
        account: '请输入客户账号',
        name: '请输入客户名称',
        phone: '请输入客户电话'
      },
      messages: {
        addSuccess: '客户新增成功',
        delTip: '您勾选的数据中，存在非零站点的客户将不会被删除!'
      }
    },
    validation: {
      countryCodeRequired: '请选择国家码',
      phoneRequired: '请输入手机号'
    }
  },
  tree: {
    rootNode: '根节点',
    actions: {
      expand: '展开',
      collapse: '收起',
      search: '搜索',
      add: '新增',
      edit: '编辑',
      delete: '删除',
      save: '保存',
      cancel: '取消'
    },
    messages: {
      addSuccess: '新增成功',
      editSuccess: '编辑成功',
      deleteSuccess: '删除成功',
      deleteConfirm: '确定要删除 "{name}" 吗?', // 支持参数替换
      deleteTitle: '警告',
    }
  },
  org: {
    title: '组织树',
    title1: '部门树',
    placeholder: {
      search: '输入组织名称筛选',
      orgName: '请输入组织名称'
    },
    dialog: {
      addTitle: '新增组织',
      editTitle: '编辑组织',
      parentOrg: '所属组织',
      orgName: '组织名称'
    },
    messages: {
      validation: {
        orgNameRequired: '请输入组织名称'
      }
    }
  },
  region: {
    title: '区域树',
    placeholder: {
      search: '区域名称搜索',
      nodeName: '请输入节点名称',
      leader: '请选择负责人'
    },
    dialog: {
      addTitle: '新建区域',
      editTitle: '编辑区域',
      nodeType: '节点类型',
      parentNode: '上级节点',
      nodeName: '节点名称',
      leader: '负责人'
    },
    types: {
      group: '组 (逻辑分组)',
      region: '区域 (物理空间)'
    },
    messages: {
      validation: {
        nameRequired: '请输入节点名称',
        leaderRequired: '请选择负责人'
      }
    },
    popover: {
      regionName: '区域名称',
      managerName: '负责人名称',
      managerEmail: '负责人邮箱'
    }
  },
  // 设备信息
  device: {
    avg: '平均值',
    eventStart: '事件开始',
    eventEnd: '事件结束',
    // 设备卡片
    card: {
      // 字段标签
      type: '设备类型',
      sn: '序列号',
      model: '设备型号',
      region: '区域',

      // 状态标签
      status: {
        online: '在线',
        offline: '离线',
        alarm: '报警',
        fault: '故障',
        inactive: '未激活',
        normal: '正常'
      },

      // 剩余时间相关
      remaining: '剩余',
      days: '天',
      tooltip: {
        life: '剩余寿命',
        replaceDate: '更换日期',
        firstOnline: '首次上线时间'
      },

      // 操作按钮 (Tooltip)
      actions: {
        edit: '编辑设备',
        view: '预览视频',
        migration: '设备迁移',
        delete: '删除设备'
      }
    },
    // 列表
    list: {
      bulkAction: '批量操作',
    },
    actions: {
      batchDelete: '批量删除',
      deviceMigrate: '设备迁移', // 新增
      deviceAdd: '新增设备',
      confirm: '确定',
      cancel: '取消'
    },
    messages: {
      warning: '提示',
      batchDeleteConfirm: '确定要删除选中的设备吗？此操作不可恢复。',
      deleteSuccess: '删除成功',
      addSuccess: '设备添加成功'
    },
    // 设备新增抽屉
    drawer: {
      title: {
        add: '新增设备'
      }
    },
    // 设备表单
    form: {
      deviceName: '设备名称',
      region: '所属区域',
      deviceModel: '设备型号',
      connectWay: '接入方式',
      serialNumber: '序列号',
      deviceCode: '设备编码',
      imeiMac: 'IMEI/MAC',
      mapAddress: '部件地址映射',
      username: '登录名称',
      password: '登录密码',
      superiorLimit: '上限阈值',
      lowerLimit: '下限阈值',
      randomGet: '随机获取',
      uniqueCode: 'IMEI/MAC',
      devUsername: '登录名称',
      devPassword: '登录密码'
    },
    // 表单验证
    validation: {
      required: '请输入{field}',
      selectRequired: '请选择{field}',
      formatError: '{field}格式不正确',
      lowerThanUpper: '下限阈值必须小于上限阈值',
      pleaseInputDeviceName: '请输入设备名称',
      pleaseSelectRegion: '请选择所属区域',
      pleaseSelectDeviceModel: '请选择设备型号',
      pleaseSelectConnectWay: '请选择接入方式',
      pleaseInputSerialNumber: '请输入序列号',
      pleaseInputDeviceCode: '请输入设备编码',
      pleaseInputImeiMac: '请输入IMEI/MAC',
      pleaseSelectMapAddress: '请选择部件地址映射',
      pleaseInputUsername: '请输入登录名称',
      pleaseInputPassword: '请输入登录密码',
      pleaseInputSuperiorLimit: '请输入上限阈值',
      pleaseInputLowerLimit: '请输入下限阈值',
      pleaseInputIMEI: '请输入15位IMEI号',
      pleaseInputCode: '请输入设备编码',
      pleaseInputUniqueCode: '请输入IMEI/MAC'
    },
    // 提示信息
    tips: {
      imei: 'IMEI：设备IMEI号，15位数字',
      mac: 'MAC：设备MAC地址，12位十六进制字符',
      code: '设备编码：设备唯一编码',
      passwordTip1: '1、如果未修改过设备密码，则传设备底部标签中（或二维码中）8位数字的安全码；',
      passwordTip2: '2、如果修改了设备密码，则传修改后的设备密码；',
      passwordTip3: '3、如果未修改过设备密码，且该设备底部标签中（或二维码中）没有8位数字的安全码，则传空即可。'
    },
    // 按钮
    buttons: {
      submit: '确认提交',
      submitAndAddDetector: '保存并添加探测器',
      randomGet: '随机获取'
    },
    filter: {
      typeLabel: '设备类型',
      unlimited: '不限',
      placeholder: '搜索设备类型',
      selected: '已选',
      clear: '清空',
      statusLabel: '设备状态',
      categories: {
        alarm: '报警状态',
        online: '在线状态',
        fault: '故障状态'
      },
      options: {
        alarm: {
          0: '报警',
          1: '正常'
        },
        online: {
          0: '离线',
          1: '在线',
          2: '未激活',
        },
        fault: {
          0: '故障',
          1: '正常'
        }
      }
    },
  },
  // 设备详情
  deviceDetail: {
    tabs: {
      detectorInfo: '探测器信息',
      videoInfo: '视频通道信息',
      deviceBasicInfo: '设备基本信息',
      zone: '防区',
      detector: '探测器',
      video: '视频通道',
      alarmLog: '报警日志',
      faultLog: '故障日志',
      onlineOfflineRecord: '在离线记录',
      otherMessageRecord: '其他消息记录',
      deviceMonitoringValue: '监测值',
      deviceConfiguration: '配置'
    },
    monitorValue: {
      unit: '单位',
      report: '上报',
      monitorTrend: {
        allData: '全量数据',
        history: '历史数据',
        max: '最大值',
        min: '最小值',
        alarmUpper: '报警上限',
        alarmLower: '报警下限',
        propertyValue: '数值',
        alarmLogStartTime: '平台接收时间',
      },
      wifi: {
        normal: '正常',
        abnormal: '异常 ',
        noNetwork: '无网络 ',
        relativelyPoor: '较差 ',
        sameAs: '一般 ',
        preferably: '较好 ',
        veryPoor: '极差 ',
        excellent: '极好',
        tall: '高',
        low: '低',
        fault: '故障',
        weak: '弱 ',
        centre: '中 ',
        strong: '强 ',
        other: '其他 ',
        good: '良',
        poor: '差',
        title1: 'WiFi信号强度',
        title2: '信号强度',
        title3: '1、基于CSQ判断',
        title4: '2、基于RSRP和SNR判断',
        title5: '2.1、首先根据RSRP判断',
        title6: '2.2、然后根据SNR值修正',
        tips1: 'SNR差的情况, 对于整体信号等级RSRP下降一级；',
        tips2: 'SNR中的情况，对于中等/弱信号下降一级；',
        tips3: 'SNR良的情况下，不影响信号等级。',
      },
      updateTime: '更新时间',
    },
    alarmLog: {
      batchAlarmTItle: '报警批量处理',
      refresh: '刷新',
      columns: {
        platRecepTime: '平台接收时间',
        policeType: '报警类型',
        devName: '设备名称',
        deviceType: '设备类型',
        confirmStatus: '确认状态',
        confirmUserName: '确认人',
        confirmResult: '确认结果',
        confirmTime: '确认时间',
        eventStatus: '消警状态',
        alarmLogEndTime: '消警时间',
        alarmLogId: '事件ID',
      },
      batchDialog: {
        memo: '描述',
        batchAlarmInfo: '批量处理报警，不推送报警通知。',
        describePlaceholder: '请输入描述',
        allFalseAlarm: '全部误报',
        allTest: '全部测试',
      },
      seachHolder: {
        nameHolder: '请输入设备/探测器名称',
        idHolder: '请输入事件ID',
        startTime: '开始时间',
        endTime: '结束时间'
      },
      filters: {
        falseAlarm: '误报',
        test: '测试',
        fireAlarm: '火警',
        commonAlarm: '告警',
        warning: '一般告警',
        alarm: '重要告警',
        fault: '故障',
        info: '信息',
        firedAlarm: '已消警',
        unclearAlarm: '未消警',
        confirmed: '已确认',
        unconfirmed: '未确认',
        confirming: '确认中',
        processed: '已处理',
        unProcessed: '未处理',
      },
      confirmResult: {
        0: '误报',
        1: '测试',
      },
      confirmStatus: {
        0: '未确认',
        1: '已确认',
        2: '确认中',
      },
      oprate: {
        manualTurnAlarm: '手动消警',
        detail: '详情',
        handle: '处理',
        clearAlarmTip: '手动消警只改变设备在平台报警状态，请谨慎使用！',
        prompt: '提示',
      },
      dialog: {
        alarmDetail: '报警详情',
        alarmProcess: '报警处理',
        alarmInfo: '报警信息',
        alarmId: '报警日志ID',
        alarmStartTime: '平台接收时间',
        devOriginRecordTime: '设备原始记录时间',
        eventStatus: '消警状态',
        alarmEventStatus: {
          0: '已消警',
          1: '未消警',
        },
        regionPerson: '区域负责人',
        devInfo: '设备信息',
        monitorValue: '监测值',
        flowEvent: '事件流程',
        hanndleMethod: '处理方式',
        describePlaceholder: '请输入描述',
        alarmReason: '报警原因',
        setCenterPoint: '设置中心',
        amplify: '放大',
        reduce: '缩小',
        fullScreen: '全屏',
        exitFullScreen: '退出全屏',
        position: '位置信息',
        plane: '平面图',
        video: '实时视频',
        faultPic: '故障图片',
        playbackVideo: '回放视频',
        alarmPic: '报警图片',
      }
    },
    faultLog: {
      columns: {
        faultType: '故障类型',
        devRepairStatus: '设备修复状态',
        repairTime: '修复时间',
        dealState: '处理状态',
        hanndleTime: '处理时间',
        hanndler: '处理人',
      },
      dialog: {
        alarmDetail: '故障详情',
        alarmProcess: '故障处理',
        faultInfo: '故障信息',
        faultLogID: '故障日志ID',
        devRepairStatus: '设备修复状态',
        hanndleResults: '处理结果',
        faultEventStatus: {
          0: '已修复',
          1: '未修复',
        },
        zone: '防区',
        zoneNumber: '{num}防区',
        deviceName: '设备名称',
        deviceType: '设备类型',
        deviceSn: 'IMEI/MAC地址/设备编码',
        deviceId: '设备序列号',
        detailAddr: '详细地址',
        channelName: '视频通道名称',
        detectorName: '探测器名称',
        circuitNum: '回路号',
        systemAddr: '系统地址',
        controllerNum: '控制器编号',
        nodeNum: '节点号',
        channelNum: '通道号'
      }
    },
    orderIssueSuc: '下发成功，等待设备响应...'
  },

  deviceBasicInfo: {
    devName: '设备名称',
    companyName: '所属单位',
    storeName: '所属区域',
    deviceType: '设备类型',
    deviceModel: '设备型号',
    deviceId: '设备序列号',
    longitude: '经度',
    latitude: '纬度',
    onlineState: '在线状态',
    deviceStatus: '故障状态',
    monitoringStatus: '报警状态',
    connectWay: '接入方式',
    deviceSn: 'IMEI/MAC地址/设备编码',
    partsMappingAddr: '部件地址映射',
    CODE: '设备编码',
    devLoginName: '登录用户名',
    devLoginPassword: '登录密码',
    devInstallTime: '设备安装时间',
    lifeTime: '寿命',
    remainingLifeTime: '剩余寿命',
    changeDate: '更换日期',
    priorityValue: '重点状态',
    deviceOperation: '设备操作',
    deviceInstallPic: '设备安装图片',
    isMergeAlarms: '是否合并报警：',
    mergeAlarmsTime: '合并报警时间：',
  },

  // 防区
  zone: {
    zone: '防区',
    shieldStatus: '防区状态',
    shield: '屏蔽',
    cancelShield: '取消屏蔽',
    shieldDisabled: '屏蔽',
    shieldActive: '取消屏蔽',
    videoLinkage: '视频联动',
    alarmStatus: '报警状态',
    faultStatus: '故障状态',
    normal: '正常',
    alarm: '报警',
    fault: '故障'

  },

  detectorVideo: {
    detectorName: '探测器名称',
    storeName: '所属区域',
    deviceName: '所属设备',
    deviceId: '所属设备序列号',
    detectorType: '探测器类型',
    detectorStatus: '故障状态',
    productModel: '探测器型号',
    channelName: '视频通道名称',
    channelType: '通道类型',
    channelId: '通道号',
    onlineStatus: '在线状态',
    devChannelStatus: '故障状态',
    inputDetectorName: '请输入探测器名称',
    controllerNumber: '控制器编号',
    systemAddress: '系统地址',
    loopNumber: '回路号',
    nodeNumber: '节点号',
    channelNumber: '通道号',
    zone: '防区',
    mustBeNumber: '必须为数字',
    detectorNameAndModel: '探测器名称/型号',
    detectorSn: '探测器序列号',
    gatewayPairingProcess: '网关配对流程',
    getDetectorList: '获取探测器列表',
    statusEnum: {
      0: '故障',
      1: '正常',
    },
    onlineEnum: {
      0: '离线',
      1: '在线',
      2: '未激活',
    },
    monitorEnum: {
      0: '报警',
      1: '正常',
    },
    view: {
      detectorInfo: '探测器信息',
      videoInfo: '视频通道信息',
      devChannelStatus: '故障状态',
      channelAlarmStatus: '报警状态',
      productModel: '探测器型号',
      deviceImei: '所属设备编码',
      alarmSub: '报警订阅',
    },
    gatewayPair: {
      gatewayProcess: '网关配对流程',
      gatewayTab1: '网关 Lite版',
      gatewayTab2: '网关 Pro版',
      gatewaytitle1: '1、网关上电',
      gatewaytitle2: '2、网关配对启动',
      gatewaytitle3: '3、探测器上电',
      gatewaytitle4: '4、探测器配对启动',
      gatewaytitle5: '5、网关与探测器互联',
      gatewaydes1_1: '将设备放在家中的中心位置，并在设置过程中保持设备通电，点击 “下一步 "添加设备。',
      gatewaydes1_2: '三击网关配对按钮，绿色LED灯将开始闪烁，网关进入配对模式。',
      gatewaydes1_4: '三击探测器按钮，当看到绿光LED灯闪烁，探测器配对启动。',
      gatewaydes1_5: '等待一段时间，网关与探测器互联中。',
      gatewaydes2_2: '三击网关配对按钮，绿色LED灯将开始闪烁，网关进入配对模式；或进入设备配置界面 ， 给网关下发“ 进入配对模式 ”指令，使网关自动进入配对模式 。'
    },
  },

  // 在线/离线记录
  onlineOfflineRecord: {
    // 在离线时间、设备名称、状态、 在线、离线
    columns: {
      onlineOfflineTime: '在离线时间',
      deviceName: '设备名称',
      status: '状态',
      online: '在线',
      offline: '离线'
    }
  },

  // 其他消息记录
  otherMessageRecord: {
    // 平台接收时间、设备原始记录时间、设备名称、消息类型、状态
    columns: {
      platformReceiveTime: '平台接收时间',
      deviceOriginalRecordTime: '设备原始记录时间',
      deviceName: '设备名称',
      detectorName: '探测器名称',
      messageType: '消息类型',
      status: '状态'
    }
  },

  // 站点信息
  site: {
    // 搜索与按钮
    placeholder: {
      searchSite: '请输入站点'
    },
    // 站点交付抽屉
    delivery: {
      title: '站点交付',
      basicInfo: '基础信息',
      hostingInfo: '托管信息',
      fields: {
        customer: '交付客户',
        siteHosting: '站点托管',
        hostingPeriod: '托管周期',
        applyPermission: '申请权限：',
        deviceManagement: '设备管理',
        remoteControl: '远程控制',
        audioVideo: '音视频'
      },
      placeholders: {
        customer: '请选择客户',
        hostingPeriod: '请选择托管周期',
        duration: '请选择时长'
      },
      options: {
        on: '开启',
        off: '关闭'
      },
      periods: {
        days7: '7天',
        days30: '30天',
        days90: '90天',
        days180: '180天',
        days365: '365天',
        custom: '自定义'
      },
      durations: {
        hour1: '1小时',
        hour2: '2小时',
        hour4: '4小时',
        hour8: '8小时',
        fullPeriod: '全托管周期'
      },
      units: {
        days: '天'
      },
      tips: {
        defaultOn: '默认开启',
        hostingPeriod: '实际生效周期以客户审批通过的时间为准',
        defaultSelected: '默认勾选，1小时',
        deviceManagement: '在站点内，新增、修改、删除设备等操作',
        remoteControl: '通过平台给设备下发控制指令、参数配置、远程升级等和设备进行远程交互的操作',
        audioVideo: '视频拉流、回放、语音对讲、云台控制、鱼眼、音轨等操作'
      },
      messages: {
        submitSuccess: '站点交付成功',
        durationExceedRemaining: '{permissions}的权限时长已超过托管剩余时间，请重新选择'
      }
    },

    // 站点状态 (Status Code)
    status: {
      pendingDelivery: '待交付',
      pendingManaged: '待托管',
      pendingAcceptance: '待验收',
      pendingConfirmation: '待确认',
      managed: '托管中',
      managedExpired: '托管到期',
      delivered: '已交付'
    },

    // 表格列头
    columns: {
      siteName: '站点名称',
      siteStatus: '站点状态',
      uprn: 'UPRN',
      customerName: '客户名称',
      deviceCount: '设备数量',
      customerEmail: '邮箱',
      customerPhone: '电话',
      adminArea: '行政区划',
      address: '详细地址',
      remark: '备注',
      action: '操作',
      columnSettings: '列设置'
    },

    // 交互提示消息
    messages: {
      deleteConfirm: '确定要删除这条数据吗？',
      unsavedExit: '系统检测到您有未保存的更新，确定要退出吗？',
      exitTitle: '退出确认',
      overwriteConfirm: '确定要保存并覆盖站点数据吗？',
      saveTitle: '保存确认'
    },

    // 头部
    permissionsExpiring: '您申请的“音视频”权限将即将到期',
    applyImmediately: '立即申请',
    managed: '托管中',
    siteDelivery: '站点交付',
    siteAcceptance: '站点验收',
    entrustedApproval: '托管审批',

    // 站点验收弹窗
    acceptance: {
      title: '站点验收',
      fields: {
        result: '验收结果',
        orgName: '所属组织',
        rejectReason: '拒绝原因'
      },
      options: {
        pass: '同意',
        reject: '拒绝'
      },
      placeholders: {
        orgName: '请选择所属组织',
        result: '请选择验收结果',
        rejectReason: '请输入拒绝原因'
      },
      messages: {
        submitSuccess: '验收提交成功'
      }
    },
    applyAuth: '申请权限',
    cancelManaged: '取消托管',
    renewManaged: '托管续期',
    siteHosting: '站点托管',

    // 站点托管
    hosting: {
      fields: {
        installer: '安装商'
      },
      placeholders: {
        installer: '请选择安装商'
      }
    },

    // 取消托管
    cancelHosting: {
      title: '取消托管',
      confirmText: '确定要取消托管服务吗？',
      placeholder: '为改进我们的服务，请在下方填写客户取消托管的具体原因或客户建议',
      reasonRequired: '原因必填',
      confirmBtn: '取消托管',
      messages: {
        success: '取消托管成功'
      }
    },

    // Tab页签
    tabs: {
      all: '全部',
      managed: '托管中',
      todo: '代办',
      history: '历史记录',
      deviceMgmt: '设备管理',
      siteDetail: '站点详情',
      eventLogs: '事件日志',
      operationLogs: '操作日志'
    },

    // 详情页-通用
    basicInfo: '基本信息',
    customerInfo: '客户信息',
    installerInfo: '服务商信息',
    installer: '安装人员',
    managedInfo: '托管信息',

    // 基本信息字段
    uprn: 'UPRN',
    timezone: '时区',
    adminArea: '行政区划',
    detailedAddress: '详细地址',
    remarks: '备注',

    // 客户信息字段
    customerName: '名称',
    customerEmail: '邮箱',
    customerPhone: '电话',

    // 安装人员表格
    installerName: '安装人员姓名',
    installerPhone: '安装人员电话',
    installerEmail: '安装人员邮箱',

    // 托管信息字段
    managedPeriod: '托管周期',
    deviceMgmtDuration: '设备管理',
    remoteControl: '远程控制',
    audioVideo: '音视频',
    audioVideoPermissionsOver: '音视频权限已到期，无法继续使用',
    expired: '已到期',

    // 状态与单位
    remaining: '剩余',
    year: '年',
    month: '月',
    day: '天',
    hour: '小时',
    minute: '分',
    second: '秒',
    notApplied: '未申请',

    // 站点编辑器 (SiteEditor)
    editor: {
      fields: {
        siteName: '站点名称',
        timeZone: '时区',
        uprn: 'UPRN',
        orgName: '所属组织',
        customerAccount: '客户账号',
        phone: '电话',
        region: '行政区划',
        address: '详细地址',
        remark: '备注'
      },
      placeholders: {
        siteName: '请输入站点名称',
        timeZone: '请选择时区',
        uprn: '请输入UPRN',
        phone: '请输入电话',
        select: '请选择',
        region: '请输入行政区划',
        address: '请输入详细地址',
        remark: '请输入备注'
      },
      messages: {
        timeZoneWarning: '一旦选择，将无法修改，请谨慎操作！',
        validationFailed: '验证失败',
        uprnLengthError: 'UPRN必须为8位'
      }
    }
  },
  // 登录相关
  loginInfo: {
    login: '登录',
    pleaseInput: '请输入',
    pleaseSelect: '请选择',
    welcome: '欢迎使用视消云',
    loginTips: '登录您的账户',
    email: '邮箱',
    newEmail: '新邮箱',
    editEmail: '修改邮箱',
    noAccount: '没有账号？',
    registerNow: '立即注册',
    existingAccount: '已有账号？',
    loginNow: '立即登录',
    createAccount: '创建账号',
    basicInfo: '基本信息',
    setPsd: '设置密码',
    resetPsd: '重设密码',
    IDCheck: '身份验证',
    contry: '国家/地区',
    contryTip: '为了保证您的产品使用体验，请按照实际信况准确选择您常驻国家或地区，选择后不可修改。',
    imgCode: '图形验证码',
    dynamicCode: '动态验证码',
    GetDynamicCode: '获取验证码',
    reSend: '重新发送',
    next: '下一步',
    skip: '跳过',
    complete: '完成',
    password: '密码',
    oldPsd: '旧密码',
    confirmPsw: '确认密码',
    wrongPsw: '密码长度必须在8~32位字符之间',
    wrongPswTips: '您的密码需要包含以下规则的4条：',
    lowercase: '包含一个小写字母(a-z)',
    uppercase: '包含一个大写字母(A-Z)',
    number: '包含一个数字(0-9)',
    special: '包含一个规则内的特殊字符',
    specialTip: '特殊字符包括：',
    diffPsw: '两次输入密码不一致！',
    forgetPsw: '忘记密码？',
    forgetPswTitle: '忘记密码',
    rememberPsw: '记住密码',
    noEmailTips: '请先输入邮箱和图形验证码！',
    termsAndPolicies: '我已阅读并同意[click:1]《服务条款》[/click]和[click:2]《 隐私政策》[/click]',
    pleaseCheckPolicy: '请先阅读并勾选《服务条款》和《隐私政策》',
    dahuaGF: '版权所有 ©2021 浙江华消科技有限公司',
    zheNum1: '浙ICP备2021005411号',
    zheNum: '浙ICP07004180',
    footerT: '浙公网安备',
    footerT1: '33010802003424号',
    footerT2: '33010802005650号',
    contactUs: '联系我们',
    serviceHotline: '服务热线',
    downloadQRCode:'扫描二维码下载',
    emailCodesendS: '验证码已发送至邮箱，请注意查收',
    registerSuccess: '注册成功！',
    pswEditSuccess: '密码修改成功！',
    loginSuccess: '登录成功！',
    noUser: '用户不存在！',
    wrongEmail: '请输入正确的邮箱地址！',
  },
  msgCenter: {
    pending: '待处理',
    processed: '已处理',
    basicInfo: '基础信息',
    installerName: '客户名称',
    siteName: '站点名称',
    installerEmail: '客户邮箱',
    installerPhone: '客户电话',
    occurTime: '发生时间',
    deviceList: '设备清单',
    deviceName: '设备名称',
    serialNumber: '序列号',
    onlineStatus: '在线状态',
    faultStatus: '故障状态',
    online: '在线',
    offline: '离线',
    unactivated: '未激活',
    fault: '故障',
    normal: '正常',
    agree: '同意',
    reject: '拒绝',
    approved: '已同意',
    expired: '已失效',
    rejected: '已拒绝',
    inspect: '去验收',
    toDoItems: '待办事项',
    completedItem: '已办事项',
    viewall: '查看全部',
    notice: '通知',
    msgNotice: '消息通知',
    noDataTip: '请先选择要查看的待办事项或消息通知',
    prompt: '提示',
    rejectTip: '确定要拒绝该托管申请吗？',
    org: '所属组织',
    rejectReason: '拒绝原因',
    inputReason: '请输入拒绝原因',
    selectOrg: '请选择组织',
    notShowAgain: '不再展示',
    viewNow: '立即查看',
    canceReason: '取消原因',
    titleType: {
      site_delivery: '站点交付',
      delivery_and_apply_hosting: '交付站点并申请托管',
      site_hosting: '站点托管',
      hosting_renewal: '托管续期',
      apply_device_permission: '申请设备权限',
      site_acceptance: '站点验收',
      apply_hosting: '申请托管',
      hosting_expiring: '托管即将到期',
      hosting_expired: '托管已到期',
      cancel_hosting: '取消托管'
    },
    summary: {
      template: '您收到一条{type}消息，请及时处理，若您3天内未处理，该申请将自动失效。',
      10: '您交付的站点验收通过，请及时关注。',
      11: '您交付的站点验收被驳回，请及时关注。',
      12: '{companyName}同意您的托管申请，请及时关注。',
      13: '{companyName}拒绝您的托管申请，请及时关注。',
      14: '{companyName}同意您的托管续期申请，请及时关注。',
      15: '{companyName}拒绝您的托管续期申请，请及时关注。',
      16: '{siteName}托管即将到期，请及时关注。',
      17: '{siteName}托管已到期，请及时关注。',
      18: '{companyName}同意您的设备权限申请，请及时关注。',
      19: '{companyName}拒绝您的设备权限申请，请及时关注。',
      20: '您收到一条取消托管站点的消息，请及时关注。'
    },
    hosting: {
      device_management: '设备管理',
      remote_control: '远程控制',
      audio_video: '音视频',
      FULL_PERIOD: '全周期托管',
      HOST_PERIOD: '托管周期',
      HOST_Renewal: '托管续期',
      title: '托管信息'
    }
},
  // 设备运维
  deviceOps: {
    dashboard: "仪表板",
    siteStatus: "站点状态",
    undelivered: "未交付",
    delivered: "已交付",
    siteOrganization: "站点 / 组织",
    onlineOfflineStatistics: "设备在/离线统计",
    deviceTotal: "设备总数",
    offline: "离线",
    online: "在线",
    total: "总数",
    rate: "占比",
    unactivated: "未激活",
    faultStatusStatistics: "故障状态统计",
    firefightingEquipment: "消防设备",
    detector: "探测器",
    videoEquipment: "视频设备",
    videoChannel: "视频通道",
    normal: "正常",
    fault: "故障",
    normalRate: "正常率",
    faultTypeTop5: "故障类型TOP5",
    dataSourcedFromFaultLog: "数据来源于故障日志",
    "24VOutputOpenCircuit": "24V输出开路",
    registeredDeviceDisconnected: "注册设备掉线",
    eachElectricalConnectionFault: "备电连接故障",
    mainElectricalConnectionFault: "主电连接故障",
    detentionAlarm: "滞留报警",
    todoItems: "待办事项",
    processNow: "立即处理",
    siteOverview: "站点概览",
    undeliveredItems: "待交付",
    unaccepted: "待验收",
    unconfirmed: "待确认",
    managed: "托管中",
    managedExpired: "托管到期",
    deviceOverview: "设备概览",
    deviceStatusTrendChart: "设备状态趋势图",
    deviceOfflineRate: "设备离线率",
    deviceFaultRate: "设备故障率",
    detectorFaultRate: "探测器故障率",
    videoChannelFaultRate: "视频通道故障率",
    last7days: "近7天",
    last30days: "近30天",
    faultSystemsDistribution:"故障所属系统分布",
    smartWater:"智慧用水",
    smartElectricity:"智慧用电",
    traditionalFirefighting:"传统消防",
    videoSurveillance:"视频监控",
    industrialFirefighting:"工业消防",
    smartChargingPile:"智慧充电桩",
    intelligentEarlyWarning:"智能预警",
    more: '更多',
    placeholder: {
      select: '请选择',
      search: '请输入关键词搜索',
    }
  },
  // 事件日志
  eventLogs: {
    menu: {
      fault: '故障日志',
      alarm: '报警日志',
      onlineOffline: '在离线日志',
      other: '其他消息'
    },
    placeholder: {
      search: '请输入设备名称/探测器名称/序列号',
      searchDeviceId: '请输入设备ID',
    },
    columns: {
      deviceName: '设备名称',
      detectorName: '探测器名称',
      serialNumber: '序列号',
      deviceType: '设备类型',
      faultType: '故障类型',
      alarmType: '报警类型',
      infoType: '消息类型',
      eventType: '事件类型',
      status: '状态',
      platformReceiveTime: '平台接收时间',
      repairStatus: '修复状态',
      faultEventStatus: {
        0: '已修复',
        1: '未修复',
      },
      alarmEventStatus: {
        0: '已消警',
        1: '未消警',
      },
      repairTime: '修复时间',
      clearStatus: '消警状态',
      clearTime: '消警时间',
      deviceReportTime: '设备上报时间',
      zone: '防区',
      loopNumber: '回路号',
      channelNumber: '点位号/通道号',
      controllerAddress: '控制器编号/系统地址',
      siteName: '所属站点',
      region: '所属区域',
      action: '操作'
    }
  },
  // 操作日志
  operationLogs: {
    placeholder: {
      search: '请输入用户姓名'
    },
    columns: {
      userName: '用户姓名',
      companyName: '公司名称',
      platform: '操作平台',
      baseProductType: '用户类型',
      logType: '日志类型',
      content: '日志内容',
      ip: 'IP',
      time: '时间',
      action: '操作'
    },
    platform: {
      spWeb: 'WEB',
      userWeb: '用户端WEB',
      spApp: 'APP',
      userApp: '用户端APP'
    },
    baseProductType: {
      5: '用户端',
      101: '安装商',
    },
    detail: {
      title: '操作日志详情',
      basicInfo: '基本信息',
      changeInfo: '改动信息',
      changeField: '改动字段',
      oldValue: '改动前值',
      newValue: '改动后值'
    },
    category: {
      1: '站点管理',
      2: '设备管理',
      3: '区域管理',
      4: '设备联动',
      5: '设备上图',
      6: '服务管理',
      101: '新增站点',
      102: '编辑站点',
      201: '新增设备',
      202: '编辑设备',
      203: '删除设备',
      204: '设备迁移',
      301: '新增区域',
      302: '删除区域',
      303: '编辑区域',
      401: '新增联动规则',
      402: '编辑联动规则',
      403: '删除联动规则',
      501: '新增设备上图',
      502: '编辑设备上图',
      503: '删除设备上图',
      601: '站点交付',
      602: '站点交互并申请托管',
      603: '取消申请',
      604: '托管续期',
      605: '申请权限',
      606: '取消托管',
      607: '发起托管',
      608: '托管审批',
    }
  },
  company: {
    empty: '暂无单位',
    emptyTip: '您尚未配置单位信息，请点击下方按钮配置',
    name: '单位名称',
    creditCode: '统一社会信用代码',
    division: '行政区划',
    address: '详细地址',
    editCompany: '单位信息',
    admin: {
      title: '管理员信息',
      email: '管理员邮箱',
      phone: '管理员联系电话',
      realName: '管理员真实姓名'
    }
  },
  plans: {
    noDatatip1: '当前区域未配置平面图',
    noDataTip2: '该楼层暂无图纸，请前往“资源上图”模块进行添加'
  }
}
